import {
  getArticleRecommendationsRequest,
  getArticleRecommendationsResponse,
  getArticleRequest,
  getArticleResponse,
  searchArticlesRequest,
  searchArticlesResponse,
} from "./articles.dto";
import { apiV2 } from "./v2";

export const getArticleApi = apiV2("GET", "/articles/:alias/:articleId").withRequest(getArticleRequest).withResponse(getArticleResponse);

export const getArticleRecommendationsApi = apiV2("GET", "/articles/:alias/:articleId/recommendations")
  .withRequest(getArticleRecommendationsRequest)
  .withResponse(getArticleRecommendationsResponse);

export const searchArticlesApi = apiV2("POST", "/articles/search").withRequest(searchArticlesRequest).withResponse(searchArticlesResponse);
